export default (hit, isInit, contactUrl) => {
  const type = hit.typology
  let date = hit.date ? new Date(hit.date.date) : null

  if (date) {
    date = `${date.getDate().toString().padStart(2, '0')}.${(date.getMonth() + 1).toString().padStart(2, '0')}.${date.getFullYear()}`
  }

  return `
  <div class="card-media card-media--${type} ${type === 'video' || type === 'image' ? 'text-white' : 'text-indigo-blue'}">
    ${type !== 'document'
      ? `<button class="card-media__inner cover ${type === 'video' || type === 'image' ? 'has-overlay' : ''}" data-id="${hit.idSite}">`
      : `<a href="https://res.cloudinary.com/dl8lvr6ag/image/upload/${hit.media.singleMedia.publicId}" target="_blank" class="card-media__inner cover ${type === 'video' || type === 'image' ? 'has-overlay' : ''}">`
    }
        ${type === 'video' || type === 'image'
          ? `<img src="https://res.cloudinary.com/dl8lvr6ag/image/upload/c_fill,f_auto,q_auto,w_384,h_384/${hit.media.singleMedia.publicId}" class="object-fit-image card-media__bg" alt="" />`
          : ''
        }

        <div class="card-actu__headline items-center">
          <span class="card-press__tag mr-4">${type}</span>
          ${(type === 'video' || type === 'document') && date !== null
            ? `<span>${date}</span>`
            : ''
          }
        </div>

        ${type === 'logo'
          ? `<div class="card-media__logo rounded-bottom-right">
                <img src="https://res.cloudinary.com/dl8lvr6ag/image/upload/f_auto,q_auto,w_250/${hit.media.singleMedia.publicId}" alt="" />
              </div>`
          : ''
        }

        <div class="flex justify-end items-end w-full">
          ${type === 'document' || type === 'video'
            ? `<p class="title text-28 xl:text-32 title--semibold">${hit.title}</p>`
            : ''
          }

          <div class="card-media__drop rounded-bottom-right">
              ${type === 'video'
                ? `<svg width="13" height="13" class="icon--white">
                      <use href="#icon-play" xlink:href="#icon-play" />
                  </svg>`
                : type === 'document'
                  ? `<svg width="17" height="16" class="icon--white">
                      <use href="#icon-dl" xlink:href="#icon-dl" />
                    </svg>`
                  : `<svg width="18" height="18" class="icon--white">
                      <use href="#icon-zoom" xlink:href="#icon-zoom" />
                    </svg>`
              }
          </div>
        </div>
    ${type !== 'document'
      ? '</button>'
      : '</a>'
    }

    ${type !== 'video' && type !== 'document'
      ? `<a onclick="_paq.push(['trackEvent', 'mediatheque', 'formulaire', 'faire la demande']);" href="${contactUrl}" class="cta cta--icon card-media__link">
          ${config.trads.make_request}
          <svg width="13" height="10" class="icon--${type === 'video' || type === 'image' ? 'white' : 'indigo-blue'}">
              <use href="#icon-arrow-right" xlink:href="#icon-arrow-right" />
          </svg>
      </a>`
      : ''
    }
  </div>
  `
}
